export default {
    links: {
        email: 'tim@coder.si',
        linkedIn: 'https://www.linkedin.com/in/timrijavec/',
    },
};
